import React, { useState } from 'react';

import PedigreeCard from '../../../../Statistics/Cards/PedigreeCard/PedigreeCard';
import { usePedigree } from '../../../../Statistics/Cards/PedigreeCard/usePedigree';

function DogCardFamilyTree(props: DogCardFamilyTreeProps) {
    const [generations, setGenerations] = useState<number>(3);
    const dogId = props.dogId != undefined && props.dogId != "" ? Number(props.dogId) : undefined;
    const pedigree = usePedigree(dogId, generations);

    return (
        <PedigreeCard
            dog={pedigree.data}
            dogId={dogId}
            loading={pedigree.loading}
            generations={generations}
            onGenerationsChange={setGenerations}
            generationOptions={[2, 3, 4, 5]}
            onOpenDog={props.onClick}
        />
    );
}

class DogCardFamilyTreeProps {
    dogId!: string | undefined;
    onClick?: (dogId: string) => void;
}

export default DogCardFamilyTree;
